/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Societe Api
 * API de gestion des societes
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface GetSocieteSocieteItem401Response
 */
export interface GetSocieteSocieteItem401Response {
    /**
     * 
     * @type {string}
     * @memberof GetSocieteSocieteItem401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface GetSocieteSocieteItem403Response
 */
export interface GetSocieteSocieteItem403Response {
    /**
     * 
     * @type {string}
     * @memberof GetSocieteSocieteItem403Response
     */
    'error'?: string;
    /**
     * 
     * @type {GetSocieteSocieteItem403ResponseException}
     * @memberof GetSocieteSocieteItem403Response
     */
    'exception'?: GetSocieteSocieteItem403ResponseException;
}
/**
 * 
 * @export
 * @interface GetSocieteSocieteItem403ResponseException
 */
export interface GetSocieteSocieteItem403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof GetSocieteSocieteItem403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSocieteSocieteItem403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface GetSocieteSocieteItem404Response
 */
export interface GetSocieteSocieteItem404Response {
    /**
     * 
     * @type {string}
     * @memberof GetSocieteSocieteItem404Response
     */
    'error'?: string;
    /**
     * 
     * @type {GetSocieteSocieteItem404ResponseException}
     * @memberof GetSocieteSocieteItem404Response
     */
    'exception'?: GetSocieteSocieteItem404ResponseException;
}
/**
 * 
 * @export
 * @interface GetSocieteSocieteItem404ResponseException
 */
export interface GetSocieteSocieteItem404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof GetSocieteSocieteItem404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSocieteSocieteItem404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface SocieteJsonldSocieteReadItem
 */
export interface SocieteJsonldSocieteReadItem {
    /**
     * 
     * @type {SocieteJsonldSocieteReadItemContext}
     * @memberof SocieteJsonldSocieteReadItem
     */
    '@context'?: SocieteJsonldSocieteReadItemContext;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'siren'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'raisonSociale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'adresse1'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'adresse2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'adresse3'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'adresse4'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'pays'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'libPays'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'compteBanque'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'numeroRcs'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'numeroTvaIntracommunautaire'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItem
     */
    'codeBic'?: string | null;
}
/**
 * @type SocieteJsonldSocieteReadItemContext
 * @export
 */
export type SocieteJsonldSocieteReadItemContext = SocieteJsonldSocieteReadItemContextOneOf | string;

/**
 * 
 * @export
 * @interface SocieteJsonldSocieteReadItemContextOneOf
 */
export interface SocieteJsonldSocieteReadItemContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItemContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof SocieteJsonldSocieteReadItemContextOneOf
     */
    'hydra': SocieteJsonldSocieteReadItemContextOneOfHydraEnum;
}

export const SocieteJsonldSocieteReadItemContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type SocieteJsonldSocieteReadItemContextOneOfHydraEnum = typeof SocieteJsonldSocieteReadItemContextOneOfHydraEnum[keyof typeof SocieteJsonldSocieteReadItemContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface SocieteSocieteReadItem
 */
export interface SocieteSocieteReadItem {
    /**
     * 
     * @type {number}
     * @memberof SocieteSocieteReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'siren'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'raisonSociale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'adresse1'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'adresse2'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'adresse3'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'adresse4'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'pays'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'libPays'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'compteBanque'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'numeroRcs'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'numeroTvaIntracommunautaire'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocieteSocieteReadItem
     */
    'codeBic'?: string | null;
}

/**
 * SocietesApi - axios parameter creator
 * @export
 */
export const SocietesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les informations d\'une societe
         * @summary Récupérer les informations d\'une societe
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocieteSocieteItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocieteSocieteItem', 'id', id)
            const localVarPath = `/societe/societes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SocietesApi - functional programming interface
 * @export
 */
export const SocietesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SocietesApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les informations d\'une societe
         * @summary Récupérer les informations d\'une societe
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocieteSocieteItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocieteJsonldSocieteReadItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocieteSocieteItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SocietesApi.getSocieteSocieteItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SocietesApi - factory interface
 * @export
 */
export const SocietesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SocietesApiFp(configuration)
    return {
        /**
         * Récupérer les informations d\'une societe
         * @summary Récupérer les informations d\'une societe
         * @param {SocietesApiGetSocieteSocieteItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocieteSocieteItem(requestParameters: SocietesApiGetSocieteSocieteItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<SocieteJsonldSocieteReadItem> {
            return localVarFp.getSocieteSocieteItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSocieteSocieteItem operation in SocietesApi.
 * @export
 * @interface SocietesApiGetSocieteSocieteItemRequest
 */
export interface SocietesApiGetSocieteSocieteItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof SocietesApiGetSocieteSocieteItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof SocietesApiGetSocieteSocieteItem
     */
    readonly xIdSociete?: number
}

/**
 * SocietesApi - object-oriented interface
 * @export
 * @class SocietesApi
 * @extends {BaseAPI}
 */
export class SocietesApi extends BaseAPI {
    /**
     * Récupérer les informations d\'une societe
     * @summary Récupérer les informations d\'une societe
     * @param {SocietesApiGetSocieteSocieteItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocietesApi
     */
    public getSocieteSocieteItem(requestParameters: SocietesApiGetSocieteSocieteItemRequest, options?: RawAxiosRequestConfig) {
        return SocietesApiFp(this.configuration).getSocieteSocieteItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



